import { registerRootComponent } from 'expo';
import React from 'react';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { mnohsAPIClient } from './api/MnohsAPIClient';
import { Environment } from './Environment';
import { store } from './model/store';
import { Routes } from './Routes';
import { LocalLoggingService } from './services/LoggingService';

/** Starts up the app by setting the environment and registering the root component */
export const startup = () => {
  Environment.set({
    api: mnohsAPIClient({
      baseURL: process.env.MNOHS_API_URL!,
    }),
    config: {
      authDomain: process.env.AUTH0_DOMAIN!,
      authClientId: process.env.AUTH0_CLIENT_ID!,
    },
    services: {
      logger: LocalLoggingService,
    },
  });

  const AppContainer = () => (
    <Provider store={store}>
      <Routes />
      <ToastContainer />
    </Provider>
  );

  registerRootComponent(AppContainer);
};
